import { LogLevel } from '@environment/enums/log-level.enum';
import { sendLogToSentry } from '@shared/sentry';

export function getHttpVersion(): string | undefined {
  try {
    // @ts-ignore
    return window.chrome.loadTimes().connectionInfo;
  } catch (e) {
    sendLogToSentry({ message: 'Could not get http version', level: LogLevel.Warning });
    return undefined;
  }
}
